import { Schema } from 'effect';

import { GtmItemsArraySchema } from './items';
import { Number } from '../primitive/number';
import { StringOptionalProperty, StringRequired } from '../primitive/string';

/**
 * https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtm#make_a_purchase_or_issue_a_refund
 */
export const GtmPurchaseEventSchema = Schema.Struct({
  event: Schema.Literal('track.purchase'),
  ecommerce: Schema.Struct({
    id: StringRequired, // Required for purchase events
    value: Number,
    value_to_pay: Number,
    tax: Number,
    shipping: Number,
    payment: Number,
    payment_type: StringOptionalProperty,
    shipping_type: StringOptionalProperty,
    currency: StringRequired,
    coupon: StringOptionalProperty,
    discount: Number,
    items: GtmItemsArraySchema,
    customer: Schema.optional(
      Schema.Struct({
        email: StringRequired,
        phone: StringOptionalProperty,
      })
    ),
  }),
}).annotate({ identifier: 'GtmPurchaseEventSchema' });

export type GtmPurchaseEvent = Schema.Schema.Type<typeof GtmPurchaseEventSchema>;
